import { Component } from '@angular/core';

@Component( {
    selector: 'psv-person-search-form',
    templateUrl: './person-search-form.component.html',
    standalone: false
} )
export class PersonSearchFormComponent { }
